import { gql } from '@apollo/client';
import type { Image } from '@snapchat/mw-contentful-schema';

import type { ContentfulTypedSysProps } from '../../types/contentful';
import type { RichText } from '../../types/RichText';
import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';
import { fragments as imageFragments } from '../Image/query';
import type { ImageDataProps } from '../Image/types';
import type { VideoDataProps } from '../Video/types';

export const fragments = {
  all: gql`
    fragment CustomerQuoteAll on CustomerQuote {
      ...ContentfulSysId
      author {
        json
      }
      authorName
      body {
        json
      }
      media {
        __typename
        ... on Video {
          ...VideoAll
        }
        ... on Image {
          ...ImageAll
        }
      }
      logo {
        ...ImageAll
      }
      isLongQuote
    }
    ${contentfulSysIdFragment}
    ${imageFragments.all}
  `,
};

export interface CustomerQuoteProps extends ContentfulTypedSysProps<'CustomerQuote'> {
  author: RichText;
  authorName: string; // DEPRECATED: use author instead
  body: RichText;
  logo?: Image;
  isLongQuote?: boolean;
  media?: VideoDataProps | ImageDataProps;
}

export const query = gql`
  query CustomerQuotesQuery($preview: Boolean!, $locale: String!, $id: String!) {
    customerQuote(preview: $preview, locale: $locale, id: $id) {
      ...CustomerQuoteAll
    }
  }
  ${fragments.all}
`;

export interface CustomerQuoteDataProps extends ContentfulTypedSysProps<'CustomerQuote'> {
  customerQuote: CustomerQuoteProps;
}
